<template>
  <v-data-table
    :items="software"
    :headers="headerType(type)"
    :options.sync="options"
    :footer-props="{
      'items-per-page-options': [10, 20, 30, 40, 50, -1]
    }"
    class="elevation-1"
    dense
  >
    <template v-slot:top>
      <v-row>
        <v-col
          class="col-lg-10 col-md-9 col-sm-9"
        />
        <v-spacer></v-spacer>
        <v-col
          v-if="type === 'assyst' && (userHasPermission('edit_software'))"
          class="mb-2"
        >
          <assyst-software-dialog
            ref="softDialog"
          />
        </v-col>
        <v-col
          v-else-if="type === 'ipaas' && (userHasPermission('edit_software'))"
          class="mb-2"
        >
          <ipaas-software-dialog
            ref="ipaasDialog"
          />
        </v-col>
        <v-col
          v-else-if="type === 'itom' && (userHasPermission('edit_software'))"
          class="mb-2"
        >
          <itom-software-dialog
            ref="itomDialog"
          />
        </v-col>
        <v-col
          v-else-if="type === 'itom_bridge' && (userHasPermission('edit_software'))"
          class="mb-2"
        >
          <itom-bridge-dialog
            ref="itomBridgeDialog"
          />
        </v-col>
        <v-col
          v-else-if="type === 'rest_bridge' && (userHasPermission('edit_software'))"
          class="mb-2"
        >
          <rest-bridge-dialog
            ref="restBridgeDialog"
          />
        </v-col>
      </v-row>
    </template>
    <template
      v-slot:item.assyst_version="{ item }"
    >
      <router-link
        :to="`assyst/${item.assyst_software_id}`"
        class="text-decoration-none"
      >
        {{ item.assyst_version }}
      </router-link>
    </template>
    <template
      v-slot:item.ipaas_version="{ item }"
    >
      <router-link
        :to="`ipaas/${item.ipaas_software_id}`"
        class="text-decoration-none"
      >
        {{ item.ipaas_version }}
      </router-link>
    </template>
    <template
      v-slot:item.itom_version="{ item }"
    >
      <router-link
        :to="`itom/${item.itom_software_id}`"
        class="text-decoration-none"
      >
        {{ item.itom_version }}
      </router-link>
    </template>
    <template v-slot:item.released="{ value }">
      <v-icon
        :color="iconColour(value)"
      >
        {{ displayIcon(value) }}
      </v-icon>
    </template>
    <template v-slot:item.expiry_date="{ item }">
      <v-chip
        :color="softwareChipColour(item.expiry_date)"
        small
      >
        {{ softwareEndOfLife(item.expiry_date) }}
      </v-chip>
      
    </template>
    <template v-slot:item.count="{ item }">
      {{ contractCount(item.contracts) }}
    </template>
    <template
      v-slot:item.actions="{ item }"
    >
      <v-icon
        v-if="(userHasPermission('edit_software'))"
        small
        class="mr-2"
        @click="editVersion(item)"
      >
        mdi-pencil
      </v-icon>
    </template>
  </v-data-table>
</template>
<script>
  import { get } from 'vuex-pathify'
  export default {
    name: 'SoftwareTable',
    props: {
      software: Array,
      type: String,
    },
    data () {
      return {
        assyst_headers: [
          { value: 'assyst_version', text: 'Version', width: '20%'},
          { value: 'assyst_package_name', text: 'Package Name'},
          { value: 'azure_package_name', text: 'Azure Package Name'},
          { value: 'build_number', text: 'Build Number'},
          { value: 'java_version', text: 'Java Version'},
          { value: 'count', text: 'Contracts'},
          { value: 'released', text: 'Released'},
          { value: 'expiry_date', text: 'Support Ends'},
        ],
        ipaas_headers: [
          { value: 'ipaas_version', text: 'Version', width: '20%'},
          { value: 'ipaas_package_name', text: 'Package Name'},
          { value: 'ipaas_azure_package_name', text: 'Azure Package Name'},
          { value: 'ipaas_installer', text: 'IPaaS Installer'},
          { value: 'java_version', text: 'Java Version'},
          { value: 'count', text: 'Contracts'},
          { value: 'released', text: 'Released'},
          { value: 'expiry_date', text: 'Support Ends'},
        ],
        itom_headers: [
          { value: 'itom_version', text: 'Version', width: '20%'},
          { value: 'itom_package_name', text: 'Package Name'},
          { value: 'itom_azure_package_name', text: 'Azure Package Name'},
          { value: 'count', text: 'Contracts'},
          { value: 'expiry_date', text: 'Support Ends'},
        ],
        itom_bridge_headers: [
          { value: 'itom_bridge_version', text: 'Version', width: '20%'},
          { value: 'itom_bridge_file_name', text: 'Filename'},
        ],
        rest_bridge_headers: [
          { value: 'rest_bridge_version', text: 'Version', width: '20%'},
          { value: 'rest_bridge_file_name', text: 'Filename'},
        ],
        options: {
          itemsPerPage: -1,
          sortBy: ['assyst_version', 'ipaas_version', 'itom_version', 'itom_bridge_version', 'rest_bridge_version'],
          sortDesc: [true, true, true, true, true],
        },
      }
    },
    computed: {
      ...get('user', [
        'user',
      ]),
    },
    mounted() {
      if (this.userHasPermission('edit_software')) {
        this.assyst_headers.push({ value: 'actions', text: 'Actions', sortable: false })
        this.ipaas_headers.push({ value: 'actions', text: 'Actions', sortable: false })
        this.itom_headers.push({ value: 'actions', text: 'Actions', sortable: false })
        this.rest_bridge_headers.push({ value: 'actions', text: 'Actions', sortable: false })
        this.itom_bridge_headers.push({ value: 'actions', text: 'Actions', sortable: false })
      }
    },
    methods: {
      userHasPermission: function (perm) {
        let perms = this.user.permissions.map(a => a.name)
        return perms.includes(perm)
      },
      displayIcon: function (item) {
        if (item === 'y') {
          return 'mdi-check'
        } else {
          return 'mdi-close'
        }
      },
      iconColour: function (item) {
        if (item === 'y') {
          return 'success'
        } else {
          return 'error'
        }
      },
      softwareEndOfLife: function (date) {
        // let d = new Date(date)
        // let softwareEOLDate = new Date(d.getFullYear(), d.getMonth(), d.getDate())
        return new Date(date).toDateString()
        // return softwareEOLDate.toDateString()
      },
      softwareChipColour: function (date) {
        // let d = new Date(date)
        let currentDate = new Date()
        let softwareEOLDate = new Date(date)
        let softwareNearEOLDate = new Date(softwareEOLDate.getFullYear(), softwareEOLDate.getMonth() - 6, softwareEOLDate.getDate())

        if (currentDate > softwareEOLDate) {
          return 'error'
        } else if (currentDate > softwareNearEOLDate) {
          return 'warning'
        } else {
          return 'success'
        }
      },
      editVersion: function (item) {
        if (this.type === 'assyst') {
          this.$refs.softDialog.editVersion(item)
        } else if (this.type === 'ipaas') {
          this.$refs.ipaasDialog.editVersion(item)
        } else if (this.type === 'itom') {
          this.$refs.itomDialog.editVersion(item)
        } else if (this.type === 'itom_bridge') {
          this.$refs.itomBridgeDialog.editVersion(item)
        } else if (this.type === 'rest_bridge') {
          this.$refs.restBridgeDialog.editVersion(item)
        }
      },
      contractCount: function (contracts) {
        return contracts.filter(element => element.status !== 'DR' && element.status !== 'Decommissioned' && element.deleted === 'n').length
      },
      headerType: function (type) {
        switch (type) {
          case 'assyst':
            return this.assyst_headers
          case 'ipaas':
            return this.ipaas_headers
          case 'itom':
            return this.itom_headers
          case 'itom_bridge':
            return this.itom_bridge_headers
          case 'rest_bridge':
            return this.rest_bridge_headers
          default:
            break;
        }
      }
    }
  }
</script>